module.exports = __webpack_public_path__ + "img/id1.c9d7ca8e.png";